(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-show-on-scroll"]) return;
  try {
    
  class ShowOnScrollHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Set z-index on mobile to ensure scroll header is below main header
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.classList.add('header-wrapper--hidden-mobile');
        const sectionHeader = this.closest('.section-header');
        if (sectionHeader) {
          sectionHeader.style.zIndex = '1';
        }
        return;
      }

      this.header = this.closest('.section-header');
      this.mainHeader = null;
      this.mainHeaderBounds = {};
      this.mainHeaderHeight = 0;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.setMainHeaderHeight.bind(this));

      // Start hidden
      this.classList.remove('show-on-scroll-visible');

      // Initialize main header detection (with delay to ensure DOM is ready)
      setTimeout(() => {
        this.initializeMainHeader();
        // Check initial scroll position after initialization
        this.onScroll();
      }, 200);

      // Also try immediately
      this.initializeMainHeader();

      // Check initial scroll position
      requestAnimationFrame(() => {
        this.onScroll();
      });
    }

    initializeMainHeader() {
      // Find main header
      const mainHeaderWrapper = document.querySelector('.header-wrapper--main');
      if (mainHeaderWrapper) {
        this.mainHeader = mainHeaderWrapper.closest('.section-header');
        if (this.mainHeader) {
          this.setMainHeaderHeight();
          this.createObserver();
        }
      }

      // If still not found, try querying all section-headers and find the first one with main wrapper
      if (!this.mainHeader) {
        const allSectionHeaders = document.querySelectorAll('.section-header');
        allSectionHeaders.forEach((sectionHeader) => {
          if (sectionHeader.querySelector('.header-wrapper--main')) {
            this.mainHeader = sectionHeader;
            this.setMainHeaderHeight();
            this.createObserver();
            return;
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setMainHeaderHeight() {
      if (this.mainHeader) {
        this.mainHeaderHeight = this.mainHeader.offsetHeight;
      } else {
        // Fallback: try to measure the main header wrapper directly
        const mainHeaderWrapper = document.querySelector('.header-wrapper--main');
        if (mainHeaderWrapper) {
          this.mainHeaderHeight = mainHeaderWrapper.offsetHeight;
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver(
        (entries) => {
          this.mainHeaderBounds = entries[0].intersectionRect;
        },
        {
          threshold: [0, 1],
        }
      );

      if (this.mainHeader) {
        observer.observe(this.mainHeader);
      }
    }

    onScroll() {
      // Hide on mobile
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.classList.remove('show-on-scroll-visible');
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Get main header height - always try to measure fresh, but cache for performance
      let mainHeaderHeight = this.mainHeaderHeight;

      // Try to get fresh measurement from main header wrapper first
      const mainHeaderWrapper = document.querySelector('.header-wrapper--main');
      if (mainHeaderWrapper) {
        const measuredHeight = mainHeaderWrapper.offsetHeight;
        if (measuredHeight > 0) {
          mainHeaderHeight = measuredHeight;
          this.mainHeaderHeight = mainHeaderHeight;
        }
      }

      // Try section header as fallback
      if ((!mainHeaderHeight || mainHeaderHeight < 50) && this.mainHeader) {
        const measuredHeight = this.mainHeader.offsetHeight;
        if (measuredHeight > 0) {
          mainHeaderHeight = measuredHeight;
          this.mainHeaderHeight = mainHeaderHeight;
        }
      }

      // Use cached value if we have one and current measurement is invalid
      if (!mainHeaderHeight || mainHeaderHeight < 50) {
        if (this.mainHeaderHeight && this.mainHeaderHeight >= 50) {
          mainHeaderHeight = this.mainHeaderHeight;
        } else {
          // Final fallback
          mainHeaderHeight = 100;
          this.mainHeaderHeight = mainHeaderHeight;
        }
      }

      // Show based purely on scroll position - independent of main header state
      // Show when scrolled past the header height (with small buffer)
      const showThreshold = mainHeaderHeight + 10; // Show 10px after passing header
      const hideThreshold = mainHeaderHeight - 30; // Hide when well above header

      // Show when scrolled past threshold - regardless of main header state
      if (scrollTop >= showThreshold) {
        if (!this.classList.contains('show-on-scroll-visible')) {
          this.classList.add('show-on-scroll-visible');
        }
      }
      // Hide when scrolled back up
      else if (scrollTop <= hideThreshold) {
        if (this.classList.contains('show-on-scroll-visible')) {
          this.classList.remove('show-on-scroll-visible');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('show-on-scroll-header', ShowOnScrollHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Set z-index on mobile to ensure main header is above scroll header
      if (window.matchMedia('(max-width: 749px)').matches && this.header) {
        this.header.style.zIndex = '10';
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();

      // Check initial scroll position after a short delay
      setTimeout(() => {
        this.onScroll();
      }, 100);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      this.headerBounds = {
        top: 0,
        bottom: this.header ? this.header.offsetHeight : 0,
      };

      let observer = new IntersectionObserver(
        (entries) => {
          if (entries[0]) {
            const rect = entries[0].boundingClientRect;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            this.headerBounds = {
              top: rect.top + scrollTop,
              bottom: rect.bottom + scrollTop,
            };
          }
        },
        {
          threshold: [0, 1],
        }
      );

      if (this.header) {
        observer.observe(this.header);
      }

      // Also set initial bounds based on header height
      if (this.header) {
        this.headerBounds.bottom = this.header.offsetHeight;
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Get header height
      const headerHeight = this.header ? this.header.offsetHeight : 100;
      const isPastHeader = scrollTop > headerHeight;
      const isCurrentlyHidden = this.header.classList.contains('shopify-section-header-hidden');

      // Always hide when past header - regardless of scroll direction
      if (isPastHeader && !isCurrentlyHidden) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      // Only show when back at top
      else if (!isPastHeader && isCurrentlyHidden) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // Ensure animate class is added for smooth transition
      if (!this.header.classList.contains('animate')) {
        this.header.classList.add('animate');
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
